import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { Grid, Card, CardHeader, Typography, Divider, CardContent, FormControl, InputLabel, MenuItem, Select, TextField, Button, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Paper, CircularProgress, IconButton, Dialog, DialogActions, DialogContent, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material'

import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';

import moment from 'moment';
import 'moment/locale/es-mx';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { usePages } from '../../hooks/usePages';

import { DownloadFile } from '../../helpers/DownloadFile';
import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { Layout } from '../../components/Layout'

import { TableTheadStyle, TablePaddingStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { DialogDocumento } from '../../dialogs/DialogDocumento';
import { DialogExpediente } from '../../dialogs/DialogExpediente';
import { DialogAmparo } from '../../dialogs/DialogAmparo';
import { DialogExhortoRecibido } from '../../dialogs/DialogExhortoRecibido';
import { DialogIrregular } from '../../dialogs/DialogIrregular';

import { ObtenerAutoridadesMaterias } from '../../connections/catalogos/AutoridadConnection';
import { ObtenerTipoConsecutivo } from '../../connections/catalogos/TipoConsecutivoConnection';
import { ObtenerMateria } from '../../connections/catalogos/MateriaConnection';
import { ObtenerLibroActuarios, DescargarLibroActuarios, GuardarObservacionesLibroActuarios } from '../../connections/libros-electronicos/LibroActuarioConnection';

import { MateriaProps } from '../../interfaces/catalogos/MateriaInterface';
import { AutoridadProps } from '../../interfaces/catalogos/AutoridadInterface';
import { TipoConsecutivoProps } from '../../interfaces/catalogos/TipoConsecutivoInterface';
import { defaultLibroActuarios, LibroActuariosProps } from '../../interfaces/libros-electronicos/LibroActuariosInterface';

export const LibroActuariosPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [loading, setLoading] = useState( false );
    const [searching, setSearching] = useState( false );
    const [loadingDescarga, setLoadingDescarga] = useState( false );
    const [loadingObservaciones, setLoadingObservaciones] = useState( false );

    const [openDialogObservaciones, setOpenDialogObservaciones] = useState( false );
    const [openDocument, setOpenDocument] = useState( false );
    const [doc, setDoc] = useState( '' );

    const [openDialogExpediente, setOpenDialogExpediente] = useState( false );
    const [openDialogAmparo, setOpenDialogAmparo] = useState( false );
    const [openDialogExhortoRecibido, setOpenDialogExhortoRecibido] = useState( false );
    const [openDialogIrregular, setOpenDialogIrregular] = useState( false );

    const [filtroAplicado, setFiltroAplicado] = useState( false );
    const [recordCount, setRecordCount] = useState( 0 );

    const [numeroReferencia, setNumeroReferencia] = useState( '' );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [tipoConsecutivo, setTipoConsecutivo] = useState( 0 );
    const [tipoConsecutivoArray, setTipoConsecutivoArray] = useState<TipoConsecutivoProps[]>( [] );

    const [mostrarPor, setMostrarPor] = useState( 1 );

    const [libroSelected, setLibroSelected] = useState<LibroActuariosProps>( defaultLibroActuarios );

    const [rows, setRows] = useState<LibroActuariosProps[]>( [] );
    const [observaciones, setObservaciones] = useState( '' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const handleClear = () => {

        setNumeroReferencia( '' );

        setMateria( 0 );
        setAutoridad( 0 );
        setAutoridadArray( [] );
        setTipoConsecutivo( 0 );
        setMostrarPor( 1 );

        resetPage();
        setFiltroAplicado( false );

    }

    const handleBuscar = async () => {

        setSearching( true );
        setLoading( true );
        setRecordCount( 0 );
        setRows( [] );
        setFiltroAplicado( true );

    }

    const handleDescargar = async () => {

        setLoadingDescarga( true );

        await DescargarLibroActuarios({ idAutoridad: autoridad, numeroReferencia, tipo: mostrarPor, idTipoConsecutivo: tipoConsecutivo }).then( resp => {

            setTimeout(() => {

                if ( resp ) {

                    DownloadFile( `Libro-actuarios-${ Date.now() }.xlsx`, resp );

                    setLoadingDescarga( false );

                }
                else {

                    setLoadingDescarga( false );
                }

            }, 700);

        });

    }

    const handleOpenReferencia = ( value: LibroActuariosProps ) => {

        setLibroSelected( value );

        if ( value.tipoTramite === 'Expediente' )        setOpenDialogExpediente( true );
        else if ( value.tipoTramite === 'Amparo' )       setOpenDialogAmparo( true );
        else if ( value.tipoTramite === 'Exhorto recibido' ) setOpenDialogExhortoRecibido( true );
        else if ( value.tipoTramite === 'Irregular' )    setOpenDialogIrregular( true );

    }

    const handleOpenObservaciones = ( value: LibroActuariosProps ) => {

        setLibroSelected( value );
        setObservaciones( value.observaciones ?? '' );
        setOpenDialogObservaciones( true );

    }

    const handleGuardarObservaciones = async () => {

        setLoadingObservaciones( true );

        await GuardarObservacionesLibroActuarios({ id: libroSelected.idLibroActuarios, observaciones }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if (  success ) {

                    dispatch( openSnackbar({ message, variant: 'success' }));
                    setOpenDialogObservaciones( false );
                    setLoadingObservaciones( false );

                    const newRows = rows.map((elem) => {
                        if (elem.idLibroActuarios === libroSelected.idLibroActuarios) {
                            return { ...elem, observaciones: observaciones };
                        }
                        return elem;
                    });
                    setRows(newRows);

                }
                else {

                    dispatch( openSnackbar({ message, variant: 'success' }));
                    setLoadingObservaciones( false );

                }

            }, 700);

        });

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoConsecutivo().then( resp => {
                setTipoConsecutivoArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {
                setAutoridadArray( resp );
            });

        }

        Obtener();

    }, [ materia ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRecordCount( 0 );
            setRows( [] );

            await ObtenerLibroActuarios({ idAutoridad: 0, numeroReferencia: '', tipo: 1, idTipoConsecutivo: 0, page, rowsPerPage }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordCount );
                    setRows( resp.records );

                    setLoading( false );

                }, 700);

            });

        }

        if ( !filtroAplicado ) {
            Obtener();
        }

    }, [ filtroAplicado, page, rowsPerPage ])

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRecordCount( 0 );
            setRows( [] );

            await ObtenerLibroActuarios({ idAutoridad: autoridad, numeroReferencia, tipo: mostrarPor, idTipoConsecutivo: tipoConsecutivo, page, rowsPerPage }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordCount );
                    setRows( resp.records );

                    setLoading( false );
                    setSearching( false );

                }, 700);

            });

        }

        if ( filtroAplicado ) {
            Obtener();
        }

    }, [ filtroAplicado, autoridad, numeroReferencia, mostrarPor, tipoConsecutivo, page, rowsPerPage ])

    return (
        <Layout breadcrumbs={ [{ text: 'Libros electrónicos' }, { text: 'Libro de actuarios' }] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                {
                    ( administrador || coordinador )
                    &&
                        <Grid size={{ md: 12, xs: 12 }} textAlign={ 'start' }>

                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>

                        </Grid>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>

                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={<Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography>}
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Materia</InputLabel>

                                        <Select
                                            label='Materia'
                                            value={ materia }
                                            onChange={ (e) => setMateria( e.target.value ) }
                                            disabled={ filtroAplicado }

                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                materiaArray
                                                .filter( ({ idMateria }) => idMateria === 5 || idMateria === 6 )
                                                .map(({ idMateria, descripcion }) => (
                                                    <MenuItem key={ idMateria } value={ idMateria }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <FormControl fullWidth disabled={ materia === 0 || filtroAplicado }>
                                        <InputLabel>Autoridad</InputLabel>

                                        <Select
                                            label='Autoridad'
                                            value={ autoridad }
                                            onChange={ (e) => setAutoridad( e.target.value ) }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                autoridadArray.map(({ idAutoridad, descripcion }) => (
                                                    <MenuItem key={ idAutoridad } value={ idAutoridad }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <FormControl fullWidth disabled={ filtroAplicado }>
                                        <InputLabel>Tipo de consecutivo</InputLabel>

                                        <Select
                                            label='Tipo de consecutivo'
                                            value={ tipoConsecutivo }
                                            onChange={ (e) => setTipoConsecutivo( e.target.value ) }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                tipoConsecutivoArray
                                                .filter(({ idTipoConsecutivo }) => idTipoConsecutivo === 1 || idTipoConsecutivo === 2 || idTipoConsecutivo === 3 || idTipoConsecutivo === 6)
                                                .map(({ idTipoConsecutivo, descripcion }) => (
                                                    <MenuItem key={ idTipoConsecutivo } value={ idTipoConsecutivo }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <TextField
                                        fullWidth
                                        label='Número de expediente'
                                        placeholder='1/2026'
                                        value={ numeroReferencia }
                                        onChange={ (e) => setNumeroReferencia( e.target.value ) }
                                        disabled={ filtroAplicado }
                                        onKeyDown={ (e) => e.key === 'Enter' ? handleBuscar() : {} }
                                        slotProps={{
                                            input: { autoComplete: 'off' },
                                            inputLabel: { shrink: true }
                                        }}
                                    />

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <Button
                                        fullWidth
                                        color={ filtroAplicado ? 'secondary' : 'primary' }
                                        variant={ filtroAplicado ? 'outlined' : 'contained' }
                                        loading={ searching }
                                        disabled={ autoridad === 0 && mostrarPor === 1 && tipoConsecutivo !== 0 && numeroReferencia === '' }
                                        onClick={ () => { filtroAplicado ? handleClear() : handleBuscar() } }
                                    >
                                        { filtroAplicado ? 'Limpiar filtro' : 'Buscar' }
                                    </Button>

                                </Grid>

                                <Grid size={{ md: 12, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <FormLabel>Mostrar:</FormLabel>

                                        <RadioGroup row>
                                            <FormControlLabel control={ <Radio checked={ mostrarPor === 1 } onChange={ () => setMostrarPor( 1 ) } disabled={ filtroAplicado } /> } label='Todas las notificaciones' />
                                            <FormControlLabel control={ <Radio checked={ mostrarPor === 2 } onChange={ () => { setMostrarPor( 2 ); setTipoConsecutivo( 0 ); setNumeroReferencia( '' ); } } disabled={ filtroAplicado } /> } label='Enviadas a central de actuarios' />
                                            <FormControlLabel control={ <Radio checked={ mostrarPor === 3 } onChange={ () => { setMostrarPor( 3 ); setTipoConsecutivo( 0 ); setNumeroReferencia( '' ); } } disabled={ filtroAplicado } /> } label='Realizadas por el(los) actuario(s) del Juzgado' />
                                        </RadioGroup>

                                    </FormControl>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }} textAlign={ 'end' }>

                    <Button
                        color='secondary'
                        variant='outlined'
                        loading={ loadingDescarga }
                        onClick={ handleDescargar }
                    >
                       Descargar información
                    </Button>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table sx={{ minHeight: rows.length === 0 ? 450 : 0 }}>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Cédula notificación</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Referencia</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '12%', fontWeight: 'bold' }}>Auto a notificar</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '12%', fontWeight: 'bold' }}>Tipo de notificación</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}>Notificar a</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Observaciones</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '5%', fontWeight: 'bold' }}></TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    rows.map( ( elem , index) => {

                                        const { referencia, numeroBoleta, fechaAutoNotificar, lugar, personaNotificar, tipoParte, tipoNotificacion, formaNotificacion, tipoAcuerdo, subTipoAcuerdo, observaciones, notificacion } = elem;

                                        return <TableRow key={ index } >

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Button
                                                    fullWidth
                                                    variant='contained'
                                                    onClick={ () => { setOpenDocument( true ); setDoc( notificacion ); } }
                                                >
                                                    Ver
                                                </Button>

                                                {
                                                    numeroBoleta
                                                    &&
                                                        <Typography variant='subtitle1' mt={ 1 }>
                                                            { numeroBoleta }
                                                        </Typography>
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Button
                                                    fullWidth
                                                    variant='contained'
                                                    onClick={ () => handleOpenReferencia( elem ) }
                                                >
                                                    { referencia }
                                                </Button>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Typography variant='subtitle1' fontWeight={ 'bold' }>{ tipoAcuerdo }</Typography>

                                                { subTipoAcuerdo !== '' && <Typography variant='subtitle2' fontWeight={ 'normal' } fontSize={ 14 }>({ subTipoAcuerdo })</Typography> }

                                                {
                                                    fechaAutoNotificar
                                                    &&
                                                        <>

                                                            <Typography variant='subtitle1' mt={ 1 }>
                                                                { moment( fechaAutoNotificar ).format('DD-MM-YYYY') }
                                                            </Typography>

                                                            <Typography variant='caption' color='text.secondary'>
                                                                { moment( fechaAutoNotificar ).format('hh:mm a') }
                                                            </Typography>

                                                        </>
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Typography variant='subtitle1' fontWeight={ 'bold' }>{ tipoNotificacion }</Typography>
                                                <Typography color='secondary' variant='subtitle2' fontWeight={ 'normal' } fontSize={ 14 }>({ formaNotificacion })</Typography>

                                            </TableCell>

                                            <TableCell>

                                                <Typography variant='subtitle1'>
                                                    <strong>{ personaNotificar.toUpperCase() }</strong> <Typography color='secondary'>({ tipoParte })</Typography>
                                                </Typography>

                                                <Typography color='secondary' variant='subtitle2' fontWeight={ 'normal' } fontSize={ 12 } mt={ 1 }>{ lugar }</Typography>

                                            </TableCell>

                                            <TableCell sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}> { observaciones } </TableCell>

                                            <TableCell>

                                                <IconButton color='primary' onClick={ () => handleOpenObservaciones( elem ) }>
                                                    <EditIcon />
                                                </IconButton>

                                            </TableCell>

                                        </TableRow>

                                    })
                                }

                                {
                                    ( rows.length === 0 && !loading )
                                    ?
                                        <TableRow style={{ height: 73 }}>

                                            <TableCell colSpan={ 7 } align='center'>

                                                <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                            </TableCell>

                                        </TableRow>
                                    :
                                        loading
                                        &&
                                            <TableRow style={{ height: 73 }}>

                                                <TableCell colSpan={ 7 } align='center'>

                                                    <CircularProgress size={ 32 } />

                                                </TableCell>

                                            </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 2 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { recordCount } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        colSpan={ 5 }
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        count={ recordCount }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage='Filas por página'
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />
                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <DialogExpediente
                expediente={ libroSelected.expediente }
                openDialog={ openDialogExpediente }
                handleCloseDialog={ () => setOpenDialogExpediente( false ) }
            />

            <DialogAmparo
                amparo={ libroSelected.amparo }
                openDialog={ openDialogAmparo }
                handleCloseDialog={ () => setOpenDialogAmparo( false ) }
            />

            <DialogExhortoRecibido
                exhortoRecibido={ libroSelected.exhortoRecibido }
                openDialog={ openDialogExhortoRecibido }
                handleCloseDialog={ () => setOpenDialogExhortoRecibido( false ) }
            />

            <DialogIrregular
                irregular={ libroSelected.irregular }
                openDialog={ openDialogIrregular }
                handleCloseDialog={ () => setOpenDialogIrregular( false ) }
            />

            <DialogDocumento
                documento={ doc }
                openDialog={ openDocument }
                handleCloseDialog={ () => setOpenDocument( false ) }
            />

            <Dialog
                fullWidth
                maxWidth='sm'
                open={ openDialogObservaciones }
            >

                <DialogContent sx={ DialogContentStyle }>

                    <TextField
                        sx={{ mt: 1 }}
                        label='Observaciones'
                        variant='outlined'
                        multiline
                        rows={ 4 }
                        fullWidth
                        value={ observaciones }
                        onChange={ (e) => setObservaciones( e.target.value ) }
                        slotProps={{
                            input: { autoComplete: 'off' },
                            inputLabel: { shrink: true }
                        }}
                    />

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button color='secondary' disabled={ loadingObservaciones } onClick={ () => setOpenDialogObservaciones( false ) }>Cancelar</Button>
                    <Button variant='contained' loading={ loadingObservaciones } onClick={ handleGuardarObservaciones }>Guardar</Button>

                </DialogActions>

            </Dialog>

        </Layout>
    )
}